import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ShopWindowItem } from '../../model/shop-window-item';

/**
 * Component responsible for displaying product monitoring information in the shop window.
 *
 * @remarks
 * This component receives a `ShopWindowItem` and displays its values, such as base value,
 * monthly value, total value, and maximum installment, formatted for presentation.
 * It also emits an event when the product is clicked.
 *
 * @example
 * ```html
 * <pme-product-monitore
 *   [shopWindowItem]="item"
 *   [periodicity]="periodicity"
 *   (clickOnProduct)="handleProductClick()">
 * </pme-product-monitore>
 * ```
 *
 * @input shopWindowItem - The product item to display.
 * @input periodicity - The periodicity string (e.g., "monthly").
 * @output clickOnProduct - Event emitted when the product is clicked.
 */
@Component({
    selector: 'pme-product-monitore',
    templateUrl: './product-monitore.component.html',
    styleUrls: ['./product-monitore.component.scss'],
    standalone: false
})
export class ProductMonitoreComponent implements OnInit {

  @Input() shopWindowItem: ShopWindowItem;
  @Input() periodicity: string;

  @Output() clickOnProduct = new EventEmitter<void>()

  constructor() { }
  ngOnInit(): void {
  }

  getValue(type: any): any{
    switch (type) {
      case 'baseValue':
        return this.shopWindowItem.baseValue.toFixed(2).replace('.', ',');
      case 'monthlyValue':
        return this.shopWindowItem.paymentMethods.find(paymentMethod => paymentMethod.identifier === 'ADYEN')?.maxInstallmentValue.toFixed(2).replace('.', ',');
      case 'totalValue':
        return this.shopWindowItem.totalValue.toFixed(2).replace('.', ',');
      case 'maxInstallment':
        return this.shopWindowItem.paymentMethods.find(paymentMethod => paymentMethod.identifier === 'ADYEN')?.maxInstallment;
      default:
        console.warn(`Unknown type: ${type}`);
        return '';
    }
  }

  isAppliedDiscounts(): boolean {
    return this.shopWindowItem.appliedDiscounts && this.shopWindowItem.appliedDiscounts.length > 0;
  }

  onClick(): void {
    this.clickOnProduct.emit();
  }

}
